import React from 'react';
import styled from 'styled-components';
import { boulder } from '@parchment/atoms';
import { RequiredElementsIcon as RequiredElementsIconRaw } from '@parchment/icons';
export default function RequiredAsterisk() {
  return /*#__PURE__*/React.createElement(Message, null, /*#__PURE__*/React.createElement(RequiredElementsIcon, null), " All items marked with a red asterisk are required.");
}
const Message = /*#__PURE__*/styled.div.withConfig({
  displayName: "RequiredAsterisk__Message",
  componentId: "sc-1xibjj0-0"
})(["color:", ";display:flex;align-items:center;"], boulder);
const RequiredElementsIcon = /*#__PURE__*/styled(RequiredElementsIconRaw).withConfig({
  displayName: "RequiredAsterisk__RequiredElementsIcon",
  componentId: "sc-1xibjj0-1"
})(["font-size:2.5em;top:0;margin-right:8px;"]);